<template>
    <new-student-backend-layout
        page-title="Live Webinars"
        content-bg-color="gray-125"
        header-bg-color="white"
        super-banner-color="primary-150"
    >
        <template #super_banner>
            <LiveEventsNextLiveBanner :highlight-webinar="highlightWebinar" />
        </template>

        <template #page_header>
            <div class="flex flex-col gap-1">
                <h1 class="text-[26px] font-bold">Live Events</h1>
                <div class="text-[16px] text-gray-700">
                    Live webinars with our certified EMS instructors
                </div>
            </div>
        </template>

        <template #content>
            <div
                class="flex items-center justify-start px-4 pb-4 pt-8 lg:px-10"
            >
                <Link
                    :href="route('student.live-events.index')"
                    class="border border-gray-800 px-3 py-2 text-[16px] text-gray-800 hover:cursor-pointer"
                >
                    Webinar Schedule
                </Link>
                <Link
                    :href="route('student.live-events.past-recordings')"
                    class="border border-gray-800 bg-gray-800 px-3 py-2 text-[16px] text-white hover:cursor-pointer"
                >
                    Past Recordings
                </Link>
            </div>

            <div class="px-4 py-4 lg:px-10">
                <div class="w-full bg-white p-4 shadow">
                    <div class="mb-8 text-[18px] font-semibold text-gray-925">
                        Past Recordings
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                        <template v-for="video in pastWebinarVideos">
                            <student-video-card
                                :show-date="true"
                                :video="video"
                            />
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </new-student-backend-layout>
</template>

<script>
import NewStudentBackendLayout from "@/_Layouts/NewStudentBackendLayout.vue";
import StudentVideoCard from "@/Components/StudentVideoCard.vue";
import LiveEventsNextLiveBanner from "@/Components/LiveEventsNextLiveBanner.vue";

export default {
    name: "StudentLiveEventsIndex",
    components: {
        LiveEventsNextLiveBanner,
        StudentVideoCard,
        NewStudentBackendLayout,
    },
    props: {
        pastWebinarVideos: {
            type: Array,
            default: [],
        },
        highlightWebinar: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
